export default {
  loadingDataOnPageLoad: null,
  items: []
};
